import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { icons } from '../assets/icons/icons';
import { IconColor, IconSize, Icons } from '../enums';

const StyledIcon = styled.svg<{ $rotate?: boolean }>`
  ${({ $rotate }) => ($rotate ? tw`animate-spin` : tw``)};
`;
interface Props {
  icon: Icons;
  size?: IconSize;
  color?: IconColor;
  rotate?: boolean;
  className?: string;
}

const Icon: FC<Props> = ({
  icon,
  rotate,
  size = IconSize.small,
  color = IconColor.default,
  className,
}) => (
  <StyledIcon
    width={size}
    height={size}
    $rotate={rotate}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path fill={color} d={icons[icon]} />
  </StyledIcon>
);

export default Icon;
